import * as React from "react";
import styled from "styled-components";
import { Card, Colors, Overlay, Spinner } from "@blueprintjs/core";
import { useTl } from "../hooks";
import { ETLCodes } from "../locales";

export interface ILoadingOverlayProps {
  overlayWidth: number;
  overlayHeight: number;
  loading: boolean;
}

const CustomCard = styled(Card)`
  padding: 0.5rem;
  border-radius: 10px;
`;

const StyledOverlayContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%auto;
  flex: 1;
  align-items: center;
  &:focus {
    outline: none;
  }
`;

export const LoadingOverlay: React.FunctionComponent<ILoadingOverlayProps> = ({
  overlayWidth,
  overlayHeight,
  loading,
}) => {
  const { t } = useTl();
  return (
    <Overlay
      isOpen={loading}
      hasBackdrop={true}
      usePortal={false}
      backdropProps={{
        style: { background: "radial-gradient(#ffffff,#ffffff00)" },
      }}
    >
      <StyledOverlayContent
        style={{
          width: overlayWidth,
          height: overlayHeight,
        }}
      >
        <CustomCard elevation={4}>
          <Spinner size={24}></Spinner>
          <span style={{ color: Colors.BLACK }}>
            {t(ETLCodes.GeneralLoading)}
          </span>
        </CustomCard>
      </StyledOverlayContent>
    </Overlay>
  );
};
